export default function isFreeOfCharge(
  price: SessionType["price"] | undefined,
) {
  return !price && price === 0;
}
